import React, { useState } from 'react';
import './BookOverview.css';

const BookOverview = ({ bookData, keywords = [], cardHeight, onKeywordClick }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!bookData) return null;

  const socialLinks = bookData.SocialMediaLinks || {};
  const hasLinks = bookData.Website || socialLinks.Twitter || socialLinks.YouTube || socialLinks.LinkedIn;

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleModalClick = (e) => {
    // Close modal when clicking on backdrop (not the image)
    if (e.target.classList.contains('infographic-modal')) {
      closeModal();
    }
  };

  const getYouTubeEmbedUrl = (url) => {
    if (!url) return null;
    
    let videoId = null;
    
    // Standard YouTube URL: https://www.youtube.com/watch?v=VIDEO_ID
    if (url.includes('youtube.com/watch?v=')) {
      videoId = url.split('youtube.com/watch?v=')[1]?.split('&')[0];
    }
    // Short YouTube URL: https://youtu.be/VIDEO_ID
    else if (url.includes('youtu.be/')) {
      videoId = url.split('youtu.be/')[1]?.split('?')[0];
    }
    // Already an embed URL
    else if (url.includes('youtube.com/embed/')) {
      return url;
    }
    
    if (videoId) {
      return `https://www.youtube.com/embed/${videoId}`;
    }
    
    return null;
  };

  return (
    <div className="book-overview-card" style={{ height: cardHeight }}>
      <div className="book-cover-section">
        {bookData.InfographicUrl && (
          <img 
            src={bookData.InfographicUrl} 
            alt="Book Infographic" 
            className="book-infographic"
            onClick={openModal}
            title="Click to enlarge"
          />
        )}
        {bookData.ImagePath && (
          <img 
            src={bookData.ImagePath} 
            alt="Book Cover" 
            className="book-cover"
            style={{ height: cardHeight - 40 }}
          />
        )}
        <div className="book-author-info">
          <p><strong>Author:</strong> {bookData.Author}</p>
          <p><strong>Published:</strong> {bookData.PublicationDate}</p>
        </div>
      </div>
      
      <div className="book-info-section">
        {bookData.Description && (
          <div className="book-description">
            <p>{bookData.Description}</p>
          </div>
        )}

        {bookData.AmazonUrl && (
          <div className="amazon-link-section">
            <a 
              href={`${bookData.AmazonUrl}${bookData.AmazonUrl.includes('?') ? '&' : '?'}tag=paitar-20`} 
              target="_blank" 
              rel="noopener noreferrer"
              className="amazon-link"
            >
              📚 Purchase on Amazon
            </a>
            <span className="affiliate-disclosure">As an Amazon Associate I earn from qualifying purchases</span>
          </div>
        )}

        {keywords && keywords.length > 0 && (
          <div className="keywords-section">
            <span className="keywords-label">Keywords: </span>
            {keywords.map((kw, index) => (
              <span key={index}>
                <span 
                  className="keyword-tag" 
                  title={onKeywordClick ? `Click to add "${kw.word}" to prompt builder` : kw.concept}
                  onClick={() => onKeywordClick && onKeywordClick(kw.word)}
                  style={onKeywordClick ? { cursor: 'pointer' } : {}}
                >
                  {kw.word.toLowerCase()}
                </span>
                {index < keywords.length - 1 && <span className="keyword-separator">, </span>}
              </span>
            ))}
          </div>
        )}
        
        {hasLinks && (
          <div className="social-links">
            {bookData.Website && (
              <a href={bookData.Website} target="_blank" rel="noopener noreferrer">🌐 Website</a>
            )}
            {socialLinks.Twitter && (
              <a href={socialLinks.Twitter} target="_blank" rel="noopener noreferrer">🐦 Twitter</a>
            )}
            {socialLinks.YouTube && (
              <a href={socialLinks.YouTube} target="_blank" rel="noopener noreferrer">📺 YouTube</a>
            )}
            {socialLinks.LinkedIn && (
              <a href={socialLinks.LinkedIn} target="_blank" rel="noopener noreferrer">💼 LinkedIn</a>
            )}
          </div>
        )}
      </div>

      {/* Infographic Modal */}
      {isModalOpen && bookData.InfographicUrl && (
        <div className="infographic-modal" onClick={handleModalClick}>
          <div className="infographic-modal-content">
            <button className="modal-close-btn" onClick={closeModal}>×</button>
            <img 
              src={bookData.InfographicUrl} 
              alt="Book Infographic - Enlarged" 
              className="infographic-modal-image"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default BookOverview;